define('GameDayCore/GDModel/enums/events/EventTypes',['require','exports','module'],function(require,exports,module) {
    return {
        TFS_TIMER_TICK: "tfs_timer_tick",
        INIT_DATA_LOADED: "init_data_loaded",
        GAME_INITIALIZED: "game_data_initialized",
        PREGAME_UPDATE: "pregame_update",
        VIEW_READY: "game_view_ready",
        SCENE_STATE_UPDATE: "scene_state_changed",
        UPDATE: "abstract_update",
        PLAYS: "play_update",
        PLAYERS: "players_update",
        GAME: "game_update",
        BOXSCORE: "boxscore_update",
        BENCH: "bench_update",
        LINESCORE: "linescore_update",
        GAMECENTER: "gamecenter_update",
        SCORES: "scores_update",
        HITCHART: "hitchart_update",
        MINISCOREBOARD: "miniscoreboard_update",
        SCORING_PLAYS: "scores_update",
        INNING: "inning_update",
        ALL_INNINGS: "all_innings_update",
        PLAYER_CARD: "playercard_update",
        HOT_COLD_ZONE: "hotcoldzone_update",
        DISPLAY_CONFIG: "displayconfig_update",
        JINGLES: "jingles_update",
        TEMPLATES: "tpl_lib_update",
        VIDEO: "video_update",
        LIVE_LOOKIN: "liveLookin_update",
        GD_CONFIG: "gdConfig_update",
        SKIN_CONFIG: "skin_config_update",
        TIMECODE: "timecode_update",
        STATIC_RESOURCES: "staticresources_update",
        MOUNDBALL: "moundball_update",
        BEGIN_COMMERCIAL_BREAK: "beginCommercialBreak",
        END_COMMERCIAL_BREAK: "endCommercialBreak",
        COMMERCIAL_COMPANION_RECEIVED: "commercialCompanionReceived",
        PAGE_VISIBILITY_CHANGED: "page_visibility_changed",
		SWIFFY_COMPLETE: "swiffy_animation_complete",
        GUMBO: "gumbo_updated"
    }
});

